import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { validateToken } from "../../api/password";
import { errorCodes } from "../../constants/errors";
import Loading from "../../components/Loading";
import { routes } from "../../api/paths";

type ParseTokenProps = {
  token: string | null;
};

export default function ParseToken({ token }: ParseTokenProps) {
  const history = useHistory();

  useEffect(() => {
    async function parseToken() {
      try {
        await validateToken(token);
        history.push(routes.PASSWORD_SETUP_URL + "?token=" + token);
      } catch (error: any) {
        if (error.response && error.response.status === errorCodes.NOT_FOUND) {
          history.push(routes.ACCESS_DENIED_URL);
        } else if (
          error.response &&
          error.response.status === errorCodes.UNAUTHORIZED
        ) {
          history.push(routes.EXPIRED_TOKEN_URL);
        }
      }
    }
    parseToken();
  }, []);

  return <Loading />;
}
